const getClientId = () => {
  return process.env.REACT_APP_OKTA_CLIENT_ID || '0oa7169u06ouBjfKA356';
};

module.exports = getClientId;
